import { render, staticRenderFns } from "./CRSidebarDialog.vue?vue&type=template&id=d0c74bbc&scoped=true"
import script from "./CRSidebarDialog.vue?vue&type=script&lang=js"
export * from "./CRSidebarDialog.vue?vue&type=script&lang=js"
import style0 from "./CRSidebarDialog.vue?vue&type=style&index=0&id=d0c74bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c74bbc",
  null
  
)

export default component.exports